

// // import React, { useState, useEffect, useRef } from "react";
// // import axios from "axios";
// // import misionn from "../profileimage/mision.webp";
// // import vision from "../profileimage/vision.jpg";
// // import { FaEdit, FaSave, FaEllipsisV } from "react-icons/fa";
// // import "./missionvissioncards.css"

// // const MissionVisionCards = () => {
// //   const [mission, setMission] = useState("");
// //   const [visionDesc, setVisionDesc] = useState("");
// //   const [vendorId, setVendorId] = useState(null);
// //   const [aboutUsId, setAboutUsId] = useState(null);
// //   const [isMissionEditing, setIsMissionEditing] = useState(false);
// //   const [isVisionEditing, setIsVisionEditing] = useState(false);
// //   const [showMissionEditButton, setShowMissionEditButton] = useState(false);
// //   const [showVisionEditButton, setShowVisionEditButton] = useState(false);
// //   const [showMissionThreeDots, setShowMissionThreeDots] = useState(true);
// //   const [showVisionThreeDots, setShowVisionThreeDots] = useState(true);

// //   const timeoutRef = useRef(null);
// //   const missionEditButtonRef = useRef(null);
// //   const visionEditButtonRef = useRef(null);
// //   const missionThreeDotsRef = useRef(null);
// //   const visionThreeDotsRef = useRef(null);

// //   // Get vendorId from localStorage
// //   useEffect(() => {
// //     const storedVendorId = localStorage.getItem("vendorId");
// //     setVendorId(storedVendorId);
// //   }, []);

// //   // Fetch existing data
// //   useEffect(() => {
// //     if (vendorId) fetchAboutUsData(vendorId);
// //   }, [vendorId]);

// //   // Click outside detection - hide edit buttons immediately
// //   useEffect(() => {
// //     const handleClickOutside = (event) => {
// //       const isMissionEditButtonClicked = missionEditButtonRef.current?.contains(event.target);
// //       const isVisionEditButtonClicked = visionEditButtonRef.current?.contains(event.target);
// //       const isMissionThreeDotsClicked = missionThreeDotsRef.current?.contains(event.target);
// //       const isVisionThreeDotsClicked = visionThreeDotsRef.current?.contains(event.target);

// //       const isAnyInteractiveElementClicked = 
// //         isMissionEditButtonClicked || 
// //         isVisionEditButtonClicked || 
// //         isMissionThreeDotsClicked || 
// //         isVisionThreeDotsClicked;

// //       // If click is outside ALL interactive elements, hide everything immediately
// //       if (!isAnyInteractiveElementClicked) {
// //         // Only hide if not currently editing
// //         if (!isMissionEditing) {
// //           setShowMissionEditButton(false);
// //           setShowMissionThreeDots(true);
// //         }
// //         if (!isVisionEditing) {
// //           setShowVisionEditButton(false);
// //           setShowVisionThreeDots(true);
// //         }

// //         // Clear timeout since we're hiding immediately
// //         if (timeoutRef.current) {
// //           clearTimeout(timeoutRef.current);
// //         }
// //       }
// //     };

// //     document.addEventListener("mousedown", handleClickOutside);
// //     return () => {
// //       document.removeEventListener("mousedown", handleClickOutside);
// //     };
// //   }, [isMissionEditing, isVisionEditing]);

// //   // Auto-hide edit buttons after 5 seconds when visible (only when not editing)
// //   useEffect(() => {
// //     // Don't auto-hide if user is actively editing
// //     if (isMissionEditing || isVisionEditing) {
// //       if (timeoutRef.current) {
// //         clearTimeout(timeoutRef.current);
// //       }
// //       return;
// //     }

// //     // Set timeout for auto-hiding only when edit buttons are visible
// //     const shouldAutoHide = showMissionEditButton || showVisionEditButton;

// //     if (shouldAutoHide) {
// //       // Clear existing timeout
// //       if (timeoutRef.current) {
// //         clearTimeout(timeoutRef.current);
// //       }

// //       // Set new timeout only when not editing
// //       timeoutRef.current = setTimeout(() => {
// //         setShowMissionEditButton(false);
// //         setShowVisionEditButton(false);
// //         setShowMissionThreeDots(true);
// //         setShowVisionThreeDots(true);
// //       }, 5000); // 5 seconds
// //     }

// //     // Cleanup timeout on unmount
// //     return () => {
// //       if (timeoutRef.current) {
// //         clearTimeout(timeoutRef.current);
// //       }
// //     };
// //   }, [showMissionEditButton, showVisionEditButton, isMissionEditing, isVisionEditing]);

// //   const fetchAboutUsData = async (vendorId) => {
// //     const token = localStorage.getItem("authToken");
// //     if (!token) return;

// //     try {
// //       const res = await axios.get(
// //         `https://backend.maamaas.com/food/api/vendor/aboutus/get/${vendorId}`,
// //         { headers: { Authorization: `Bearer ${token}` } }
// //       );

// //       const data = res.data;
// //       setAboutUsId(data?.aboutUsId || null);
// //       setMission(data?.mission || "");
// //       setVisionDesc(data?.vision || "");
// //     } catch (err) {
// //       console.error("Fetch Error:", err.response?.data || err.message);
// //     }
// //   };

// //   // Send data (both POST and PUT) like About Us format
// //   const sendMissionVision = async (method) => {
// //     if (!vendorId) return alert("Vendor ID missing!");
// //     if (!mission.trim() || !visionDesc.trim()) return alert("Fields cannot be empty!");

// //     const token = localStorage.getItem("authToken");
// //     if (!token) return alert("Authorization token missing");

// //     const aboutUsData = { mission, vision: visionDesc };
// //     const formData = new FormData();
// //     formData.append("aboutUsData", new Blob([JSON.stringify(aboutUsData)], { type: "application/json" }));

// //     const url =
// //       method === "POST"
// //         ? `https://backend.maamaas.com/food/api/vendor/aboutus/add/${vendorId}`
// //         : `https://backend.maamaas.com/food/api/vendor/aboutus/update/${aboutUsId}`;

// //     try {
// //       const res = await fetch(url, {
// //         method,
// //         headers: { Authorization: `Bearer ${token}` },
// //         body: formData,
// //       });

// //       if (res.ok) {
// //         alert(method === "POST" ? "Mission & Vision added!" : "Mission & Vision updated!");
// //         fetchAboutUsData(vendorId);
// //         setIsMissionEditing(false);
// //         setIsVisionEditing(false);
// //         return true;
// //       } else {
// //         const err = await res.json();
// //         alert(`Failed: ${err.message || "Unknown error"}`);
// //         return false;
// //       }
// //     } catch (err) {
// //       console.error("Submit Error:", err);
// //       alert("Something went wrong. Please try again.");
// //       return false;
// //     }
// //   };

// //   const handleAddMissionVision = async () => {
// //     await sendMissionVision("POST");
// //   };

// //   // Step 1: Three dots click - shows edit button
// //   const handleMissionThreeDotsClick = () => {
// //     setShowMissionThreeDots(false);
// //     setShowMissionEditButton(true);
// //     // Close vision elements
// //     setShowVisionEditButton(false);
// //     setShowVisionThreeDots(true);

// //     // Reset timeout
// //     if (timeoutRef.current) {
// //       clearTimeout(timeoutRef.current);
// //     }
// //   };

// //   const handleVisionThreeDotsClick = () => {
// //     setShowVisionThreeDots(false);
// //     setShowVisionEditButton(true);
// //     // Close mission elements
// //     setShowMissionEditButton(false);
// //     setShowMissionThreeDots(true);

// //     // Reset timeout
// //     if (timeoutRef.current) {
// //       clearTimeout(timeoutRef.current);
// //     }
// //   };

// //   // Step 2 & 3: Edit/Save button click - toggles between edit and save
// //   const handleMissionEditSaveToggle = async () => {
// //     if (isMissionEditing) {
// //       // Step 3: Save - Save changes and go back to three dots
// //       if (aboutUsId) {
// //         const success = await sendMissionVision("PUT");
// //         if (success) {
// //           setShowMissionEditButton(false);
// //           setShowMissionThreeDots(true);
// //           setIsMissionEditing(false);
// //         }
// //       }
// //     } else {
// //       // Step 2: Edit - Enable editing and show save button
// //       setIsMissionEditing(true);
// //       setShowMissionEditButton(true);
// //       setShowMissionThreeDots(false);

// //       // Clear timeout when starting to edit
// //       if (timeoutRef.current) {
// //         clearTimeout(timeoutRef.current);
// //       }
// //     }
// //   };

// //   const handleVisionEditSaveToggle = async () => {
// //     if (isVisionEditing) {
// //       // Step 3: Save - Save changes and go back to three dots
// //       if (aboutUsId) {
// //         const success = await sendMissionVision("PUT");
// //         if (success) {
// //           setShowVisionEditButton(false);
// //           setShowVisionThreeDots(true);
// //           setIsVisionEditing(false);
// //         }
// //       }
// //     } else {
// //       // Step 2: Edit - Enable editing and show save button
// //       setIsVisionEditing(true);
// //       setShowVisionEditButton(true);
// //       setShowVisionThreeDots(false);

// //       // Clear timeout when starting to edit
// //       if (timeoutRef.current) {
// //         clearTimeout(timeoutRef.current);
// //       }
// //     }
// //   };

// //   // Card Component
// //   const Card = ({ 
// //     image, 
// //     title, 
// //     value, 
// //     onChange, 
// //     isEditing, 
// //     showEditButton, 
// //     onEditToggle,
// //     showThreeDots,
// //     onThreeDotsClick,
// //     editButtonRef,
// //     threeDotsRef
// //   }) => {
// //     return (
// //       <div style={{
// //         backgroundColor: "white",
// //         borderRadius: "20px",
// //         padding: "20px",
// //         width: "48%",
// //         boxShadow: "0 4px 16px rgba(0,0,0,0.1)",
// //         textAlign: "center",
// //         position: "relative",
// //         border: "none"
// //       }} className="mission-vission-cards">

// //         {/* Header with title and edit/save button */}
// //         <div className="d-flex justify-content-between align-items-center mb-2">
// //           <h5 style={{ color: "#b15cd6", margin: "5px" }}>{title}</h5>
// //           {showEditButton && (
// //             <button 
// //               ref={editButtonRef}
// //               onClick={onEditToggle} 
// //               style={sectionButtonStyle}
// //               title={isEditing ? "Save Changes" : "Edit Content"}
// //             >
// //               {isEditing ? <FaSave /> : <FaEdit />}
// //             </button>
// //           )}
// //         </div>

// //         {/* Three Dots Button - Step 1 */}
// //         {showThreeDots && (
// //           <button 
// //             ref={threeDotsRef}
// //             onClick={onThreeDotsClick}
// //             style={threeDotsStyle}
// //             title={`Edit ${title}`}
// //           >
// //             <FaEllipsisV />
// //           </button>
// //         )}

// //         {/* Image */}
// //         <img 
// //           src={image} 
// //           alt={title} 
// //           style={{
// //             width: "80px",
// //             height: "80px",
// //             objectFit: "cover",
// //             borderRadius: "50%",
// //             marginBottom: "20px",
// //             border: "2px solid #b15dc6",
// //           }} 
// //         />

// //         {/* Textarea */}
// //         <textarea
// //           value={value}
// //           onChange={(e) => onChange(e.target.value)}
// //           rows={5}
// //           readOnly={!isEditing}

// //           style={{
// //             width: "100%",
// //             fontSize: "16px",
// //             color: "#333",
// //             lineHeight: "1.2",
// //             textAlign: "justify",
// //             border: isEditing ? "0px solid transparent" : "0px solid transparent",
// //             boxShadow: isEditing ? "none" : "none",
// //             fontFamily: "math",
// //             resize: "none",
// //             outline: "none",
// //             backgroundColor: isEditing ? "#f5f4f4" : "#f5f4f4",
// //             borderRadius: "8px",
// //             padding: "10px",
// //             transition: "all 0.3s ease",
// //           }}
// //           className="hide-scrollbar"
// //         />
// //       </div>
// //     );
// //   };

// //   return (
// //     <div style={{ 
// //       border: "none", 
// //       borderRadius: "20px", 
// //       marginTop: "30px", 
// //       backgroundColor: "#b15dc6",
// //       padding: "20px 0"
// //     }}>
// //       <div className="d-flex w-100 px-4 pt-3"
// //         style={{
// //           justifyContent: "space-around",
// //         }}
// //       >
// //         <h1
// //           style={{
// //             color: "#ffffffff",
// //             fontWeight: "bold",
// //             textAlign: "center",
// //             marginBottom: "10px",
// //           }}
// //         >
// //           OUR COMMITMENTS
// //         </h1>

// //         <button onClick={handleAddMissionVision} style={buttonStyle}>
// //           Add+
// //         </button>
// //       </div>

// //       {/* Combined Mission and Vision Section */}
// //       <div
// //         className="p-4 position-relative"
// //         style={{
// //           backgroundColor: "#b15dc6ff",
// //           margin: "10px",
// //           borderRadius: "20px",
// //           display: "flex",
// //           flexDirection: "row",
// //           gap: "20px",
// //           width: "calc(100% - 20px)",
// //           alignItems: "center",
// //           justifyContent: "space-evenly",
// //           position: "relative"
// //         }}
// //       >
// //         {/* Mission Card */}
// //         <Card 
// //           image={misionn} 
// //           title="Our Mission" 
// //           value={mission} 
// //           onChange={setMission}
// //           isEditing={isMissionEditing}
// //           showEditButton={showMissionEditButton}
// //           onEditToggle={handleMissionEditSaveToggle}
// //           showThreeDots={showMissionThreeDots}
// //           onThreeDotsClick={handleMissionThreeDotsClick}
// //           editButtonRef={missionEditButtonRef}
// //           threeDotsRef={missionThreeDotsRef}
// //         />

// //         {/* Vision Card */}
// //         <Card 
// //           image={vision} 
// //           title="Our Vision" 
// //           value={visionDesc} 
// //           onChange={setVisionDesc}
// //           isEditing={isVisionEditing}
// //           showEditButton={showVisionEditButton}
// //           onEditToggle={handleVisionEditSaveToggle}
// //           showThreeDots={showVisionThreeDots}
// //           onThreeDotsClick={handleVisionThreeDotsClick}
// //           editButtonRef={visionEditButtonRef}
// //           threeDotsRef={visionThreeDotsRef}
// //         />
// //       </div>

// //       <style>
// //         {`
// //           /* Hide scrollbar across all platforms */
// //           .hide-scrollbar::-webkit-scrollbar {
// //             display: none;
// //             width: 0;
// //             height: 0;
// //           }

// //           .hide-scrollbar {
// //             -ms-overflow-style: none;
// //             scrollbar-width: none;
// //             border:none !important;
// //           }
// //         `}
// //       </style>
// //     </div>
// //   );
// // };

// // const buttonStyle = {
// //   height: "35px",
// //   borderRadius: "5px",
// //   border: "none",
// //   color: "#b15cd6",
// //   fontWeight: "bold",
// //   cursor: "pointer",
// //   width: "80px",
// //   marginLeft: "20px",
// //   marginTop: "8px",
// //   display: "flex",
// //   alignItems: "center",
// //   justifyContent: "center",
// //   gap: "5px",
// // };

// // const sectionButtonStyle = {
// //   height: "25px",
// //   borderRadius: "50%",
// //   border: "none",
// //   background: "#b15cd6",
// //   color: "#fff",
// //   fontWeight: "bold",
// //   cursor: "pointer",
// //   width: "auto",
// //   display: "flex",
// //   alignItems: "center",
// //   justifyContent: "center",
// //   gap: "5px",
// // };

// // const threeDotsStyle = {
// //   position: "absolute",
// //   top: "15px",
// //   right: "18px",
// //   background: "transparent",
// //   border: "none",
// //   color: "#b15cd6",
// //   cursor: "pointer",
// //   fontSize: "18px",
// //   padding: "5px",
// //   borderRadius: "50%",
// //   zIndex: 10,
// // };

// // export default MissionVisionCards;




// import React, { useState, useEffect, useRef } from "react";
// import axios from "axios";
// import misionn from "../profileimage/mision.webp";
// import vision from "../profileimage/vision.jpg";
// import { FaEdit, FaSave, FaEllipsisV } from "react-icons/fa";
// import "./missionvissioncards.css"

// const MissionVisionCards = () => {
//   const [mission, setMission] = useState("");
//   const [visionDesc, setVisionDesc] = useState("");
//   const [vendorId, setVendorId] = useState(null);
//   const [aboutUsId, setAboutUsId] = useState(null);
//   const [isMissionEditing, setIsMissionEditing] = useState(false);
//   const [isVisionEditing, setIsVisionEditing] = useState(false);
//   const [showMissionEditButton, setShowMissionEditButton] = useState(false);
//   const [showVisionEditButton, setShowVisionEditButton] = useState(false);
//   const [showMissionThreeDots, setShowMissionThreeDots] = useState(true);
//   const [showVisionThreeDots, setShowVisionThreeDots] = useState(true);

//   const timeoutRef = useRef(null);
//   const missionEditButtonRef = useRef(null);
//   const visionEditButtonRef = useRef(null);
//   const missionThreeDotsRef = useRef(null);
//   const visionThreeDotsRef = useRef(null);

//   // Responsive state
//   const [windowWidth, setWindowWidth] = useState(window.innerWidth);
//   const isMobile = windowWidth <= 768;
//   const isTablet = windowWidth > 768 && windowWidth <= 1024;

//   useEffect(() => {
//     const handleResize = () => setWindowWidth(window.innerWidth);
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   // Get vendorId from localStorage
//   useEffect(() => {
//     const storedVendorId = localStorage.getItem("vendorId");
//     setVendorId(storedVendorId);
//   }, []);

//   // Fetch existing data
//   useEffect(() => {
//     if (vendorId) fetchAboutUsData(vendorId);
//   }, [vendorId]);

//   // Click outside detection - hide edit buttons immediately
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       const isMissionEditButtonClicked = missionEditButtonRef.current?.contains(event.target);
//       const isVisionEditButtonClicked = visionEditButtonRef.current?.contains(event.target);
//       const isMissionThreeDotsClicked = missionThreeDotsRef.current?.contains(event.target);
//       const isVisionThreeDotsClicked = visionThreeDotsRef.current?.contains(event.target);

//       const isAnyInteractiveElementClicked = 
//         isMissionEditButtonClicked || 
//         isVisionEditButtonClicked || 
//         isMissionThreeDotsClicked || 
//         isVisionThreeDotsClicked;

//       // If click is outside ALL interactive elements, hide everything immediately
//       if (!isAnyInteractiveElementClicked) {
//         // Only hide if not currently editing
//         if (!isMissionEditing) {
//           setShowMissionEditButton(false);
//           setShowMissionThreeDots(true);
//         }
//         if (!isVisionEditing) {
//           setShowVisionEditButton(false);
//           setShowVisionThreeDots(true);
//         }

//         // Clear timeout since we're hiding immediately
//         if (timeoutRef.current) {
//           clearTimeout(timeoutRef.current);
//         }
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [isMissionEditing, isVisionEditing]);

//   // Auto-hide edit buttons after 5 seconds when visible (only when not editing)
//   useEffect(() => {
//     // Don't auto-hide if user is actively editing
//     if (isMissionEditing || isVisionEditing) {
//       if (timeoutRef.current) {
//         clearTimeout(timeoutRef.current);
//       }
//       return;
//     }

//     // Set timeout for auto-hiding only when edit buttons are visible
//     const shouldAutoHide = showMissionEditButton || showVisionEditButton;

//     if (shouldAutoHide) {
//       // Clear existing timeout
//       if (timeoutRef.current) {
//         clearTimeout(timeoutRef.current);
//       }

//       // Set new timeout only when not editing
//       timeoutRef.current = setTimeout(() => {
//         setShowMissionEditButton(false);
//         setShowVisionEditButton(false);
//         setShowMissionThreeDots(true);
//         setShowVisionThreeDots(true);
//       }, 5000); // 5 seconds
//     }

//     // Cleanup timeout on unmount
//     return () => {
//       if (timeoutRef.current) {
//         clearTimeout(timeoutRef.current);
//       }
//     };
//   }, [showMissionEditButton, showVisionEditButton, isMissionEditing, isVisionEditing]);

//   const fetchAboutUsData = async (vendorId) => {
//     const token = localStorage.getItem("authToken");
//     if (!token) return;

//     try {
//       const res = await axios.get(
//         `https://backend.maamaas.com/food/api/vendor/aboutus/get/${vendorId}`,
//         { headers: { Authorization: `Bearer ${token}` } }
//       );

//       const data = res.data;
//       setAboutUsId(data?.aboutUsId || null);
//       setMission(data?.mission || "");
//       setVisionDesc(data?.vision || "");
//     } catch (err) {
//       console.error("Fetch Error:", err.response?.data || err.message);
//     }
//   };

//   // Send data (both POST and PUT) like About Us format
//   // Update sendMissionVision function to accept parameters
// const sendMissionVision = async (method, fieldType = "both") => {
//   if (!vendorId) return alert("Vendor ID missing!");

//   // Validate based on what's being saved
//   if (fieldType === "mission" && !mission.trim()) return alert("Mission cannot be empty!");
//   if (fieldType === "vision" && !visionDesc.trim()) return alert("Vision cannot be empty!");
//   if (fieldType === "both" && (!mission.trim() || !visionDesc.trim())) return alert("Fields cannot be empty!");

//   const token = localStorage.getItem("authToken");
//   if (!token) return alert("Authorization token missing");

//   const aboutUsData = { mission, vision: visionDesc };
//   const formData = new FormData();
//   formData.append("aboutUsData", new Blob([JSON.stringify(aboutUsData)], { type: "application/json" }));

//   const url =
//     method === "POST"
//       ? `https://backend.maamaas.com/food/api/vendor/aboutus/add/${vendorId}`
//       : `https://backend.maamaas.com/food/api/vendor/aboutus/update/${aboutUsId}`;

//   try {
//     const res = await fetch(url, {
//       method,
//       headers: { Authorization: `Bearer ${token}` },
//       body: formData,
//     });

//     if (res.ok) {
//       alert(fieldType === "both" ? "Mission & Vision added!" : `${fieldType.charAt(0).toUpperCase() + fieldType.slice(1)} updated!`);
//       fetchAboutUsData(vendorId);
//       return true;
//     } else {
//       const err = await res.json();
//       alert(`Failed: ${err.message || "Unknown error"}`);
//       return false;
//     }
//   } catch (err) {
//     console.error("Submit Error:", err);
//     alert("Something went wrong. Please try again.");
//     return false;
//   }
// };

//   // Also update the Add button handler
// const handleAddMissionVision = async () => {
//   await sendMissionVision("POST", "both");
// };

//   // Step 1: Three dots click - shows edit button
//   const handleMissionThreeDotsClick = () => {
//     setShowMissionThreeDots(false);
//     setShowMissionEditButton(true);
//     // Close vision elements
//     setShowVisionEditButton(false);
//     setShowVisionThreeDots(true);

//     // Reset timeout
//     if (timeoutRef.current) {
//       clearTimeout(timeoutRef.current);
//     }
//   };

//   const handleVisionThreeDotsClick = () => {
//     setShowVisionThreeDots(false);
//     setShowVisionEditButton(true);
//     // Close mission elements
//     setShowMissionEditButton(false);
//     setShowMissionThreeDots(true);

//     // Reset timeout
//     if (timeoutRef.current) {
//       clearTimeout(timeoutRef.current);
//     }
//   };

//   // Step 2 & 3: Edit/Save button click - toggles between edit and save

// // Update the edit/save handlers to call with specific field type
// const handleMissionEditSaveToggle = async () => {
//   if (isMissionEditing) {
//     // Step 3: Save - Save changes and go back to three dots
//     if (aboutUsId) {
//       const success = await sendMissionVision("PUT", "mission");
//       if (success) {
//         setShowMissionEditButton(false);
//         setShowMissionThreeDots(true);
//         setIsMissionEditing(false);
//       }
//     } else {
//       // If no aboutUsId exists yet, create new
//       const success = await sendMissionVision("POST", "mission");
//       if (success) {
//         setShowMissionEditButton(false);
//         setShowMissionThreeDots(true);
//         setIsMissionEditing(false);
//       }
//     }
//   } else {
//     // Step 2: Edit - Enable editing and show save button
//     setIsMissionEditing(true);
//     setShowMissionEditButton(true);
//     setShowMissionThreeDots(false);

//     // Clear timeout when starting to edit
//     if (timeoutRef.current) {
//       clearTimeout(timeoutRef.current);
//     }
//   }
// };



// const handleVisionEditSaveToggle = async () => {
//   if (isVisionEditing) {
//     // Step 3: Save - Save changes and go back to three dots
//     if (aboutUsId) {
//       const success = await sendMissionVision("PUT", "vision");
//       if (success) {
//         setShowVisionEditButton(false);
//         setShowVisionThreeDots(true);
//         setIsVisionEditing(false);
//       }
//     } else {
//       // If no aboutUsId exists yet, create new
//       const success = await sendMissionVision("POST", "vision");
//       if (success) {
//         setShowVisionEditButton(false);
//         setShowVisionThreeDots(true);
//         setIsVisionEditing(false);
//       }
//     }
//   } else {
//     // Step 2: Edit - Enable editing and show save button
//     setIsVisionEditing(true);
//     setShowVisionEditButton(true);
//     setShowVisionThreeDots(false);

//     // Clear timeout when starting to edit
//     if (timeoutRef.current) {
//       clearTimeout(timeoutRef.current);
//     }
//   }
// };

//   // Responsive helper functions
//   const getCardWidth = () => {
//     if (isMobile) return "100%";
//     if (isTablet) return "48%";
//     return "45%";
//   };

//   const getContainerPadding = () => {
//     if (isMobile) return "2vh 1vw";
//     if (isTablet) return "3vh 2vw";
//     return "4vh 3vw";
//   };

//   const getTextAreaRows = () => {
//     if (isMobile) return 4;
//     if (isTablet) return 5;
//     return 6;
//   };

//   const getImageSize = () => {
//     if (isMobile) return "60px";
//     if (isTablet) return "70px";
//     return "80px";
//   };

//   const getFontSize = () => {
//     if (isMobile) return "14px";
//     if (isTablet) return "15px";
//     return "16px";
//   };

//   const getHeadingSize = () => {
//     if (isMobile) return "18px";
//     if (isTablet) return "20px";
//     return "24px";
//   };

//   const getButtonSize = () => {
//     if (isMobile) return "30px";
//     if (isTablet) return "32px";
//     return "35px";
//   };

//   // Card Component
//   const Card = ({ 
//     image, 
//     title, 
//     value, 
//     onChange, 
//     isEditing, 
//     showEditButton, 
//     onEditToggle,
//     showThreeDots,
//     onThreeDotsClick,
//     editButtonRef,
//     threeDotsRef
//   }) => {
//     return (
//       <div style={{
//         backgroundColor: "white",
//         borderRadius: "2vmin",
//         padding: isMobile ? "15px" : "20px",
//         width: getCardWidth(),
//         boxShadow: "0 0.4vmin 1.6vmin rgba(0,0,0,0.1)",
//         textAlign: "center",
//         position: "relative",
//         border: "none",
//         marginBottom: isMobile ? "15px" : "0"
//       }} className="mission-vission-cards">

//         {/* Header with title and edit/save button */}
//         <div className="d-flex justify-content-between align-items-center mb-2">
//           <h5 style={{ 
//             color: "#b15cd6", 
//             margin: "5px",
//             fontSize: isMobile ? "16px" : "18px"
//           }}>{title}</h5>
//           {showEditButton && (
//             <button 
//               ref={editButtonRef}
//               onClick={onEditToggle} 
//               style={{
//                 height: isMobile ? "22px" : "25px",
//                 borderRadius: "50%",
//                 border: "none",
//                 background: "#b15cd6",
//                 color: "#fff",
//                 fontWeight: "bold",
//                 cursor: "pointer",
//                 width: "auto",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 gap: "5px",
//                 fontSize: isMobile ? "12px" : "14px"
//               }}
//               title={isEditing ? "Save Changes" : "Edit Content"}
//             >
//               {isEditing ? <FaSave /> : <FaEdit />}
//             </button>
//           )}
//         </div>

//         {/* Three Dots Button - Step 1 */}
//         {showThreeDots && (
//           <button 
//             ref={threeDotsRef}
//             onClick={onThreeDotsClick}
//             style={{
//               position: "absolute",
//               top: isMobile ? "12px" : "15px",
//               right: isMobile ? "15px" : "18px",
//               background: "transparent",
//               border: "none",
//               color: "#b15cd6",
//               cursor: "pointer",
//               fontSize: isMobile ? "16px" : "18px",
//               padding: "5px",
//               borderRadius: "50%",
//               zIndex: 10,
//             }}
//             title={`Edit ${title}`}
//           >
//             <FaEllipsisV />
//           </button>
//         )}

//         {/* Image */}
//         <img 
//           src={image} 
//           alt={title} 
//           style={{
//             width: getImageSize(),
//             height: getImageSize(),
//             objectFit: "cover",
//             borderRadius: "50%",
//             marginBottom: isMobile ? "15px" : "20px",
//             border: "0.2vmin solid #b15dc6",
//           }} 
//         />

//         {/* Textarea */}
//         <textarea
//           value={value}
//           onChange={(e) => onChange(e.target.value)}
//           rows={getTextAreaRows()}
//           readOnly={!isEditing}
//           style={{
//             width: "100%",
//             fontSize: getFontSize(),
//             color: "#333",
//             lineHeight: "1.2",
//             textAlign: "justify",
//             border: isEditing ? "0px solid transparent" : "0px solid transparent",
//             boxShadow: isEditing ? "none" : "none",
//             fontFamily: "math",
//             resize: "none",
//             outline: "none",
//             backgroundColor: isEditing ? "#f5f4f4" : "#f5f4f4",
//             borderRadius: "0.8vmin",
//             padding: isMobile ? "8px" : "10px",
//             transition: "all 0.3s ease",
//           }}
//           className="hide-scrollbar"
//         />

//       </div>
//     );
//   };

//   return (
//     <div style={{ 
//       border: "none", 
//       borderRadius: "2vmin", 
//       marginTop: isMobile ? "2vh" : "4vh", 
//       backgroundColor: "#b15dc6",
//       padding: isMobile ? "15px 0" : "20px 0"
//     }}>
//       <div className="d-flex w-100 px-3 px-md-4 pt-3"
//         style={{
//           justifyContent: isMobile ? "space-between" : "space-around",
//           alignItems: isMobile ? "flex-start" : "center",
//           flexDirection: isMobile ? "row" : "row",
//           gap: isMobile ? "10px" : "0"
//         }}
//       >
//         <h1
//           style={{
//             color: "#ffffffff",
//             fontWeight: "bold",
//             textAlign: isMobile ? "left" : "center",
//             marginBottom: "10px",
//             fontSize: getHeadingSize(),
//             width: isMobile ? "100%" : "auto"
//           }}
//         >
//           OUR COMMITMENTS
//         </h1>

//         <button onClick={handleAddMissionVision} style={{
//           height: getButtonSize(),
//           borderRadius: "5px",
//           border: "none",
//           color: "#b15cd6",
//           fontWeight: "bold",
//           cursor: "pointer",
//           width: isMobile ? "70px" : "80px",
//           marginLeft: isMobile ? "0" : "20px",
//           marginTop: isMobile ? "0" : "8px",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           gap: "5px",
//           fontSize: isMobile ? "12px" : "14px"
//         }}>
//           Add+
//         </button>
//       </div>

//       {/* Combined Mission and Vision Section */}
//       <div
//         className="p-3 p-md-4 position-relative"
//         style={{
//           backgroundColor: "#b15dc6ff",
//           margin: isMobile ? "5px" : "10px",
//           borderRadius: "2vmin",
//           display: "flex",
//           flexDirection: isMobile ? "column" : "row",
//           gap: isMobile ? "15px" : "20px",
//           width: isMobile ? "calc(100% - 10px)" : "calc(100% - 20px)",
//           alignItems: "center",
//           justifyContent: isMobile ? "center" : "space-evenly",
//           position: "relative"
//         }}
//       >
//         {/* Mission Card */}
//         <Card 
//           image={misionn} 
//           title="Our Mission" 
//           value={mission} 
//           onChange={setMission}
//           isEditing={isMissionEditing}
//           showEditButton={showMissionEditButton}
//           onEditToggle={handleMissionEditSaveToggle}
//           showThreeDots={showMissionThreeDots}
//           onThreeDotsClick={handleMissionThreeDotsClick}
//           editButtonRef={missionEditButtonRef}
//           threeDotsRef={missionThreeDotsRef}
//         />

//         {/* Vision Card */}
//         <Card 
//           image={vision} 
//           title="Our Vision" 
//           value={visionDesc} 
//           onChange={setVisionDesc}
//           isEditing={isVisionEditing}
//           showEditButton={showVisionEditButton}
//           onEditToggle={handleVisionEditSaveToggle}
//           showThreeDots={showVisionThreeDots}
//           onThreeDotsClick={handleVisionThreeDotsClick}
//           editButtonRef={visionEditButtonRef}
//           threeDotsRef={visionThreeDotsRef}
//         />
//       </div>

//       <style>
//         {`
//           /* Hide scrollbar across all platforms */
//           .hide-scrollbar::-webkit-scrollbar {
//             display: none;
//             width: 0;
//             height: 0;
//           }

//           .hide-scrollbar {
//             -ms-overflow-style: none;
//             scrollbar-width: none;
//             border:none !important;
//           }

//           @media (max-width: 768px) {
//             .px-md-4 {
//               padding-left: 1rem !important;
//               padding-right: 1rem !important;
//             }
//             .p-md-4 {
//               padding: 1.5rem !important;
//             }
//           }

//           @media (max-width: 480px) {
//             .mission-vission-cards {
//               margin-bottom: 10px !important;
//             }
//           }
//         `}
//       </style>
//     </div>
//   );
// };

// export default MissionVisionCards;






import React, { useState, useEffect } from "react";
import axios from "axios";
import { FaEdit, FaSave } from "react-icons/fa";
import misionn from "../profileimage/mision.webp";
import vision from "../profileimage/vision.jpg";
// import { FaEdit, FaSave, FaEllipsisV } from "react-icons/fa";
// import "./missionvissioncards.css"

// Responsive container style
const containerStyle = (isMobile, isTablet) => ({
  marginTop: isMobile ? "15px" : "20px",
  padding: isMobile ? "15px 10px" : isTablet ? "25px 15px" : "1rem 30px 30px 30px",
  borderRadius: "2vmin",
  background: "rgb(177, 93, 198)",
});

// Responsive card wrapper
const cardWrapperStyle = (isMobile, isTablet) => ({
  display: "grid",
  gridTemplateColumns: window.innerWidth < 550 ? "1fr" : "repeat(auto-fit, minmax(250px, 1fr))",
  gap: isMobile ? "20px" : isTablet ? "30px" : "40px",
  maxWidth: isMobile ? "100%" : isTablet ? "90%" : "1000px",
  margin: "0 auto",
});

// Responsive base card
const baseCardStyle = (isMobile, isTablet) => ({
  backgroundColor: "#fff",
  borderRadius: isMobile ? "12px" : "18px",
  border: "1px solid #b15cd6",
  padding: isMobile ? "20px 15px" : isTablet ? "30px 20px" : "40px 30px",
  boxShadow: "0 10px 24px rgba(0,0,0,0.08)",
  textAlign: "center",
  position: "relative",
});

// Responsive title
const titleBaseStyle = (isMobile, isTablet) => ({
  fontSize: isMobile ? "18px" : isTablet ? "20px" : "24px",
  fontWeight: "700",
  marginBottom: isMobile ? "12px" : "18px",
  color: "#333",
});

// Responsive section title
const sectionTitleStyle = (isMobile, isTablet) => ({
  fontSize: isMobile ? "18px" : isTablet ? "28px" : "28px",
  fontWeight: "bold",
  color: "white",
  margin: "0",
  textAlign: isMobile ? "center" : "left",
  whiteSpace: "nowrap"
});

// Responsive header container
const headerContainerStyle = (isMobile, isTablet) => ({
  display: "flex",
  flexDirection: isMobile ? "row" : "row",
  justifyContent: isMobile ? "space-between" : "space-between",
  alignItems: isMobile ? "center" : "center",
  marginBottom: isMobile ? "20px" : "30px",
  gap: isMobile ? "15px" : "0",
  padding: "0px 00px",
});

// Responsive textarea
const textAreaStyle = (isEditing, isMobile, isTablet) => ({
  width: "100%",
  minHeight: isMobile ? "100px" : isTablet ? "120px" : "140px",
  padding: isMobile ? "10px" : "14px",
  borderRadius: "8px",
  resize: "vertical",
  fontSize: isMobile ? "14px" : "16px",
  lineHeight: "1.5",
  border: isEditing ? "0px solid #b15cd6" : "0px solid #ddd",
  outline: "none",
  boxSizing: "border-box",
  backgroundColor: isEditing ? "#f9f9f9" : "#f5f5f5",
});

// Responsive image
const imageStyle = (isMobile, isTablet) => ({
  width: isMobile ? "70px" : isTablet ? "80px" : "90px",
  height: isMobile ? "70px" : isTablet ? "80px" : "90px",
  objectFit: "cover",
  borderRadius: "50%",
  marginBottom: isMobile ? "15px" : "20px",
  border: "3px solid #b15dc6",
});

// Responsive button
const buttonStyle = (isMobile, isTablet) => ({
  color: "#b15dc6",
  fontSize: isMobile ? "12px" : isTablet ? "14px" : "14px",
  padding: isMobile ? "8px 10px" : isTablet ? "11px 20px" : "12px 24px",
  borderRadius: "5px",
  border: "none",
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: isMobile ? "6px" : "10px",
  fontWeight: "bold",
  boxShadow: "0 4px 8px rgba(177, 92, 198, 0.3)",
  // width: isMobile ? "auto" : "auto",
  // minWidth: isMobile ? "auto" : "120px",
  whiteSpace: "nowrap",
  height:isMobile ? "30px" : "35px",
  width:"80px",
});

// Card Component
const Card = ({
  image,
  title,
  value,
  onChange,
  isEditing,
  onEditToggle,
  isMobile,
  isTablet
}) => {
  return (
    <div style={baseCardStyle(isMobile, isTablet)} className="mission-vission-cards">
      {/* Edit button at top right */}
      <div style={{
        position: "absolute",
        top: isMobile ? "10px" : "15px",
        right: isMobile ? "10px" : "15px",
      }}>
        <button
          onClick={onEditToggle}
          style={{
            backgroundColor: "#b15dc6",
            color: "#fff",
            border: "none",
            borderRadius: "50%",
            width: isMobile ? "30px" : "36px",
            height: isMobile ? "30px" : "36px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            fontSize: isMobile ? "14px" : "16px",
          }}
          title={isEditing ? "Save" : "Edit"}
        >
          {isEditing ? <FaSave /> : <FaEdit />}
        </button>
      </div>

      <img src={image} alt={title} style={imageStyle(isMobile, isTablet)} />
      <h3 style={titleBaseStyle(isMobile, isTablet)}>{title}</h3>
      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        rows={isMobile ? 4 : 5}
        style={textAreaStyle(isEditing, isMobile, isTablet)}
        readOnly={!isEditing}
      />
    </div>
  );
};

// Main Component
const MissionVisionCards = () => {
  const [mission, setMission] = useState("");
  const [visionDesc, setVisionDesc] = useState("");
  const [vendorId, setVendorId] = useState(null);
  const [aboutUsId, setAboutUsId] = useState(null);
  const [isMissionEditing, setIsMissionEditing] = useState(false);
  const [isVisionEditing, setIsVisionEditing] = useState(false);

  // Responsive state
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const isMobile = windowWidth <= 768;
  const isTablet = windowWidth > 768 && windowWidth <= 1024;

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Get vendorId from localStorage
  useEffect(() => {
    const storedVendorId = localStorage.getItem("vendorId");
    setVendorId(storedVendorId);
  }, []);

  // Fetch existing data
  useEffect(() => {
    if (vendorId) fetchAboutUsData(vendorId);
  }, [vendorId]);

  const fetchAboutUsData = async (vendorId) => {
    const token = localStorage.getItem("authToken");
    if (!token) return;

    try {
      const res = await axios.get(
        `https://backend.maamaas.com/food/api/vendor/aboutus/get/${vendorId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const data = res.data;
      setAboutUsId(data?.aboutUsId || null);
      setMission(data?.mission || "");
      setVisionDesc(data?.vision || "");
    } catch (err) {
      console.error("Fetch Error:", err.response?.data || err.message);
    }
  };

  // Send data (both POST and PUT) like About Us format
  const sendMissionVision = async (method) => {
    if (!vendorId) return alert("Vendor ID missing!");
    if (!mission.trim() || !visionDesc.trim()) return alert("Fields cannot be empty!");

    const token = localStorage.getItem("authToken");
    if (!token) return alert("Authorization token missing");

    const aboutUsData = { mission, vision: visionDesc };
    const formData = new FormData();
    formData.append("aboutUsData", new Blob([JSON.stringify(aboutUsData)], { type: "application/json" }));

    const url =
      method === "POST"
        ? `https://backend.maamaas.com/food/api/vendor/aboutus/add/${vendorId}`
        : `https://backend.maamaas.com/food/api/vendor/aboutus/update/${aboutUsId}`;

    try {
      const res = await fetch(url, {
        method,
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
      });

      if (res.ok) {
        alert(method === "POST" ? "Mission & Vision added!" : "Mission & Vision updated!");
        fetchAboutUsData(vendorId);
        setIsMissionEditing(false);
        setIsVisionEditing(false);
      } else {
        const err = await res.json();
        alert(`Failed: ${err.message || "Unknown error"}`);
      }
    } catch (err) {
      console.error("Submit Error:", err);
      alert("Something went wrong. Please try again.");
    }
  };

  // Save individual card
  const saveIndividualCard = async (type) => {
    if (!vendorId) return alert("Vendor ID missing!");
    if (type === "mission" && !mission.trim()) return alert("Mission cannot be empty!");
    if (type === "vision" && !visionDesc.trim()) return alert("Vision cannot be empty!");

    const token = localStorage.getItem("authToken");
    if (!token) return alert("Authorization token missing");

    const aboutUsData = { mission, vision: visionDesc };
    const formData = new FormData();
    formData.append("aboutUsData", new Blob([JSON.stringify(aboutUsData)], { type: "application/json" }));

    const url =
      aboutUsId
        ? `https://backend.maamaas.com/food/api/vendor/aboutus/update/${aboutUsId}`
        : `https://backend.maamaas.com/food/api/vendor/aboutus/add/${vendorId}`;

    try {
      const method = aboutUsId ? "PUT" : "POST";
      const res = await fetch(url, {
        method,
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
      });

      if (res.ok) {
        alert(`${type === "mission" ? "Mission" : "Vision"} saved!`);
        fetchAboutUsData(vendorId);
        if (type === "mission") setIsMissionEditing(false);
        if (type === "vision") setIsVisionEditing(false);
      } else {
        const err = await res.json();
        alert(`Failed: ${err.message || "Unknown error"}`);
      }
    } catch (err) {
      console.error("Submit Error:", err);
      alert("Something went wrong. Please try again.");
    }
  };

  return (
    <section style={containerStyle(isMobile, isTablet)}>
      {/* HEADER SECTION - Responsive layout */}
      <div style={headerContainerStyle(isMobile, isTablet)}>
        <h1 style={sectionTitleStyle(isMobile, isTablet)}>OUR COMMITMENTS</h1>
        <button
          onClick={() => sendMissionVision("POST")}
          style={buttonStyle(isMobile, isTablet)}
        >
          Add+
        </button>
      </div>

      <div style={cardWrapperStyle(isMobile, isTablet)} className="mission-vission-card-wrapper">
        {/* Mission Card */}
        <Card
          image={misionn}
          title="Our Mission"
          value={mission}
          onChange={setMission}
          isEditing={isMissionEditing}
          onEditToggle={() => {
            if (isMissionEditing) {
              saveIndividualCard("mission");
            } else {
              setIsMissionEditing(true);
            }
          }}
          isMobile={isMobile}
          isTablet={isTablet}
        />

        {/* Vision Card */}
        <Card
          image={vision}
          title="Our Vision"
          value={visionDesc}
          onChange={setVisionDesc}
          isEditing={isVisionEditing}
          onEditToggle={() => {
            if (isVisionEditing) {
              saveIndividualCard("vision");
            } else {
              setIsVisionEditing(true);
            }
          }}
          isMobile={isMobile}
          isTablet={isTablet}
        />
      </div>

      {/* Add CSS for better responsive behavior */}
      <style>
        {`
          @media (max-width: 480px) {
            .mission-vission-cards {
              margin: 2px 5px;
            }
          }
          
          @media (max-width: 768px) {
            .mission-vission-card-wrapper {
              padding: 0 10px;
            }
          }
          
          @media (min-width: 1025px) {
            .mission-vission-card-wrapper {
              max-width: 1200px;
            }
          }
        `}
      </style>
    </section>
  );
};

export default MissionVisionCards;